import type { InvestorCommunicationStatus } from "../api/investorCommunicationsTypes";
import type { ThemeColorFn } from "../utilities/colorHelper";
import StatusChip from "./StatusChip";

interface Props {
  status: InvestorCommunicationStatus;
}

const statusColors: Record<InvestorCommunicationStatus, ThemeColorFn> = {
  Draft: (t) => t.palette.text.secondary,
  Preview: (t) => t.palette.info.dark,
  Live: (t) => t.palette.success.main,
};

const InvestorCommunicationStatusTag = ({ status }: Props) => (
  <StatusChip label={status} withDot color={statusColors[status]} />
);

export default InvestorCommunicationStatusTag;
